var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMainMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5469 2.18359L10.1719 5.68359C9.84375 5.95703 9.40625 5.95703 9.07812 5.71094L6.125 3.49609L2.29688 6.55859C1.91406 6.85938 1.36719 6.80469 1.06641 6.42188C0.765625 6.06641 0.820312 5.49219 1.20312 5.19141L5.57812 1.69141C5.87891 1.44531 6.31641 1.44531 6.64453 1.69141L9.59766 3.90625L13.4531 0.816406C13.8086 0.515625 14.3828 0.597656 14.6836 0.953125C14.9844 1.33594 14.9023 1.88281 14.5469 2.18359ZM5.25 6.75C5.25 6.28516 5.63281 5.875 6.125 5.875C6.58984 5.875 7 6.28516 7 6.75V12C7 12.4922 6.58984 12.875 6.125 12.875C5.63281 12.875 5.25 12.4922 5.25 12V6.75ZM1.75 9.375C1.75 8.91016 2.13281 8.5 2.625 8.5C3.08984 8.5 3.5 8.91016 3.5 9.375V12C3.5 12.4922 3.08984 12.875 2.625 12.875C2.13281 12.875 1.75 12.4922 1.75 12V9.375ZM9.625 7.625C10.0898 7.625 10.5 8.03516 10.5 8.5V12C10.5 12.4922 10.0898 12.875 9.625 12.875C9.13281 12.875 8.75 12.4922 8.75 12V8.5C8.75 8.03516 9.13281 7.625 9.625 7.625ZM12.25 6.75C12.25 6.28516 12.6328 5.875 13.125 5.875C13.5898 5.875 14 6.28516 14 6.75V12C14 12.4922 13.5898 12.875 13.125 12.875C12.6328 12.875 12.25 12.4922 12.25 12V6.75Z",
    fill: "#052C2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMainMenu);
export default __webpack_public_path__ + "static/media/icon_main_menu.1174ce637b803070a5482aefa77824e2.svg";
export { ForwardRef as ReactComponent };